import { createElement } from 'rax';
import { FieldElement } from '../field';
import Select from '../select';
export default class SelectField extends FieldElement {
    renderPreview(value) {
        return <Select value={value} disabled {...this.getProps()}/>;
    }
    renderControl() {
        return <Select {...this.getProps()}/>;
    }
}
SelectField.displayName = 'SelectField';
